<template>
  <div class="footer">
    <div class="footer__main">
      <div class="footer__content">
        <p class="footer__disclaimer">Copyright © Vattenfall&nbsp;AB&nbsp;Försäljning</p>
        <p class="footer__disclaimer">Box&nbsp;13, 881&nbsp;06 Näsåker | Org.nr: 556036-2138 | Säte: Solna</p>
      </div>
      <div class="footer__content">
        <p class="footer__disclaimer">Har du frågor eller funderingar om våra produkter och tjänster, tveka inte att kontakta vår kundservice på 020- 82 00 00, vardagar 8-17.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/templates/components/Footer.vue